<template>
  <generic-modal
    size="small"
    :title="$t('student password recovery')"
    icon="key"
    image="/images/icons/password_recovery.png"
    v-bind:scrolling="true"
    v-on:destroy="destroy"
    :show_ok="false"
    :show_cancel="false"
    ref="modal"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="two fields">
          <div class="field">
            <label for="">{{ $t("username") }}</label>
            <input type="text" name="username" v-model="username" />
          </div>
          <div class="field">
            <label for="">{{ $t("email") }}</label>
            <input type="text" name="email" v-model="email" />
          </div>
        </div>
        <div class="ui error message"></div>
        <div class="ui green labeled icon button" @click="recover">
          <i class="check icon"></i> {{ $t("recover") }}
        </div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import GenericModal from "@/components/GenericModal";
// import DocumentTypes from "./DocumentTypes.vue";

export default {
  components: {
    "generic-modal": GenericModal,
  },
  computed: {},
  data() {
    return {
      username: "",
      email: "",
      form: undefined,
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    recover() {
      let vm = this;
      let isValid = vm.form.form("validate form");
      if (isValid) {
        local_api(vm, "post", "/student_portal/auth/do-recover-password", {
          u: vm.username,
          e: vm.email,
        })
          .then(() => {
            success_toast(vm.$t("an email has been sent to you"));
            window.jQuery(".modal").modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
  },
  mounted() {
    let vm = this;
    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        username: ["empty"],
        email: ["empty", "email"],
      },
    });
  },
};
</script>
